export const NO_ATTENDANCE_CONTENT_ID = '93dfcca8-18be-481a-8684-b6df96e05dfe';
export const WHATSAPP_CHANNEL_ID = '6ac420f7-a9cd-4a26-af06-8a2115b60dd3';
export const DEPARTMENT_COMMERCIAL_ID = '4df8f18d-f339-4718-9712-4de711d0576e';
export const DEPARTMENT_SUPPORT_ID = '4a35fa0d-ba2a-4a57-86dc-40ccad75dfd0';